import { H1, H2, H4 } from '@shared/components/Heading';
import { HeadingProps } from '@shared/types/heading';
import { FC } from 'react';

import { COLOR } from '../types/theme';
import { colorToCss } from '../utils/theme';

export const H1Gold: FC<HeadingProps> = props => <H1 {...props} color={colorToCss(COLOR.Gold1)} />;

export const H2Gold: FC<HeadingProps> = props => <H2 {...props} color={colorToCss(COLOR.Gold1)} />;

export const H4Gray1: FC<HeadingProps> = props => <H4 {...props} color={colorToCss(COLOR.Gray1)} />;
